<template>
  <div class="chat-widget__wrapper" :class="{ 'chat-widget__wrapper--empty': chatStore.messages.length === 0 }">
    <div v-if="appStore.showLoading" class="chat-widget__messages-loading">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>Загрузка, пожалуйста, подождите...
    </div>
    <StartScreen v-else-if="chatStore.messages.length === 0" />
    <ChatMessageList v-else />
    <ScrollTop target="parent" :threshold="100" icon="pi pi-arrow-up"
               :buttonProps="{ severity: 'contrast', raised: true, rounded: true }"/>
  </div>
</template>

<script setup>
import ScrollTop from 'primevue/scrolltop';
import StartScreen from "@/modules/chat/components/instruction/StartScreen.vue";
import ChatMessageList from "@/modules/chat/components/message/ChatMessageList.vue";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import {useAppStateStore} from "@/modules/chat/stores/appStore";

const chatStore = useChatStore();
const appStore = useAppStateStore();

</script>